// extracted by mini-css-extract-plugin
export default {"form":"invoiceDataForm_form__60zY1"};